export default __webpack_public_path__ + "static/media/logo2.fa275634.png";